/**
 * Viewport sync toggles for the phase-dependent hanging protocol.
 *
 * - `sliceSyncEnabledAtom` — when true, scrolling one phase viewport advances
 *   the others by the same image index (via Cornerstone's
 *   `createImageSliceSynchronizer`).
 * - `manipulationSyncEnabledAtom` — when true, pan/zoom from one phase
 *   viewport is mirrored across the others (via
 *   `createZoomPanSynchronizer`).
 *
 * Only the three top-row + bottom-left phase slots participate; the
 * bottom-right slot is reserved for the 3D / summary panel and intentionally
 * excluded.
 */
import { atom } from "jotai";

export const sliceSyncEnabledAtom = atom<boolean>(true);
export const manipulationSyncEnabledAtom = atom<boolean>(false);
